import { Component } from "react"
import _ from "underscore"
import PropTypes from "prop-types"

const { shape, string, number, object } = PropTypes

class AssignmentAreaRestrictionSelection extends Component {
  constructor(props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
    this.handleMinGradeChange = this.handleMinGradeChange.bind(this)
    this.handleMaxGradeChange = this.handleMaxGradeChange.bind(this)
    this.handleMinAgeChange = this.handleMinAgeChange.bind(this)
    this.handleMaxAgeChange = this.handleMaxAgeChange.bind(this)
    const { restrictionType, minGrade, maxGrade, minAge, maxAge } = props.assignmentArea
    this.state = {
      restrictionType: restrictionType.toLowerCase(),
      maxGrade,
      minGrade,
      maxAge,
      minAge
    }
  }

  render() {
    const { grades, minGradeShown, maxGradeShown, assignmentArea } = this.props
    const { restrictionType, minGrade, maxGrade } = this.state
    return (
      <div>
        <NoSelection onClick={this.handleClick} restrictionType={this.state.restrictionType} />
        <GradeSelectSection
          onClick={this.handleClick}
          onMinGradeChange={this.handleMinGradeChange}
          onMaxGradeChange={this.handleMaxGradeChange}
          grades={grades}
          minGradeShown={minGradeShown}
          maxGradeShown={maxGradeShown}
          restrictionType={restrictionType}
          minGrade={minGrade}
          maxGrade={maxGrade}
        />
        <AgeSelectSection
          onClick={this.handleClick}
          onMinAgeChange={this.handleMinAgeChange}
          onMaxAgeChange={this.handleMaxAgeChange}
          restrictionType={restrictionType}
          assignmentArea={assignmentArea}
        />
      </div>
    )
  }

  handleClick(e) {
    this.setState({ restrictionType: e.target.value })
  }

  handleMinGradeChange(e) {
    let maxGrade = this.state.maxGrade
    const minGrade = Number(e.target.value)
    if (maxGrade < minGrade) {
      maxGrade = minGrade
    }
    this.setState({ minGrade, maxGrade })
  }

  handleMaxGradeChange(e) {
    this.setState({ maxGrade: Number(e.target.value) })
  }

  handleMinAgeChange(e) {
    this.setState({ minAge: e.target.value })
  }

  handleMaxAgeChange(e) {
    this.setState({ maxAge: e.target.value })
  }
}

AssignmentAreaRestrictionSelection.propTypes = {
  assignmentArea: shape({
    restrictionType: string.isRequired,
    maxGrade: number,
    minGrade: number,
    maxAge: number,
    minAge: number
  }).isRequired,
  grades: object.isRequired
}

const NoSelection = ({ onClick, restrictionType }) => {
  return (
    <div className="mb-2">
      <input
        type="radio"
        className="radio"
        id="restriction_type_none"
        name="restriction_type"
        value="none"
        onClick={onClick}
        defaultChecked={restrictionType === "none"}
      />
      <label htmlFor="restriction_type_none" className="radio-label d-ib">
        No grade or age restrictions
      </label>
    </div>
  )
}

const GradeSelectSection = ({
  onClick,
  onMinGradeChange,
  onMaxGradeChange,
  restrictionType,
  grades,
  minGrade,
  maxGrade,
  minGradeShown,
  maxGradeShown,
  selectionName
}) => {
  return (
    <div className="mb-2 d-f ai-c">
      <div className="mr-1">
        <input
          type="radio"
          className="radio"
          id="restriction_type_grade"
          name="restriction_type"
          value="grade"
          onClick={onClick}
          defaultChecked={restrictionType === "grade"}
        />
        <label htmlFor="restriction_type_grade" className="radio-label">
          Grade
        </label>
      </div>

      <div className="ml-1 d-f ai-c">
        <GradeSelect
          selectionName="min_grade"
          restrictionType={restrictionType}
          onChange={onMinGradeChange}
          minGradeShown={-1}
          minGrade={minGrade}
          maxGrade={maxGrade}
          grades={grades}
        />
        <span className="px-1">to</span>
        <GradeSelect
          selectionName="max_grade"
          restrictionType={restrictionType}
          onChange={onMaxGradeChange}
          minGradeShown={minGrade}
          minGrade={minGrade}
          maxGrade={maxGrade}
          grades={grades}
        />
      </div>
    </div>
  )
}

const GradeSelect = ({
  onChange,
  grades,
  minGrade,
  maxGrade,
  minGradeShown,
  selectionName,
  restrictionType
}) => {
  const selected = selectionName === "min_grade" ? minGrade : maxGrade
  const shownGrades = _.filter(_.keys(grades), grade => grade >= minGradeShown).sort(
    (a, b) => a - b
  )
  const gradeOptions = _.map(shownGrades, v => (
    <option key={grades[v]} value={v}>
      {grades[v]}
    </option>
  ))
  return (
    <div>
      <select
        name={`assignment_area[${selectionName}]`}
        className="select"
        value={selected}
        disabled={restrictionType !== "grade"}
        onChange={onChange}
      >
        <option value={window.NO_MIN_GRADE_AS_INT}>Any grade</option>
        {gradeOptions}
      </select>
    </div>
  )
}

const AgeSelectSection = ({
  onClick,
  onMinAgeChange,
  onMaxAgeChange,
  restrictionType,
  assignmentArea
}) => {
  const { ageRestrictionUnit } = assignmentArea
  return (
    <div className="mb-2 d-f ai-c">
      <div className="mr-1">
        <input
          type="radio"
          className="radio"
          id="restriction_type_age"
          name="restriction_type"
          value="age"
          onClick={onClick}
          defaultChecked={restrictionType === "age"}
        />
        <label htmlFor="restriction_type_age" className="radio-label">
          Age
        </label>
      </div>

      <div className="d-f ai-c ml-1">
        <AgeSelect
          selectionName="min_age"
          assignmentArea={assignmentArea}
          onChange={onMinAgeChange}
          restrictionType={restrictionType}
        />
        <span className="px-1">to</span>
        <AgeSelect
          selectionName="max_age"
          assignmentArea={assignmentArea}
          onChange={onMaxAgeChange}
          restrictionType={restrictionType}
        />
        <select
          name="assignment_area[age_restriction_unit]"
          className="select ml-1 f-1"
          defaultValue={ageRestrictionUnit}
          disabled={restrictionType !== "age"}
        >
          <option value="years">Years</option>
          <option value="months">Months</option>
        </select>
      </div>
    </div>
  )
}

const AgeSelect = ({
  onChange,
  selectionName,
  restrictionType,
  assignmentArea: { minAge, maxAge }
}) => {
  const value = selectionName === "min_age" ? minAge : maxAge
  return (
    <div className="f-1">
      <input
        type="number"
        name={`assignment_area[${selectionName}]`}
        min="0"
        defaultValue={value}
        onChange={onChange}
        disabled={restrictionType !== "age"}
      />
    </div>
  )
}

export default AssignmentAreaRestrictionSelection
